import { Title, WrapperFlex } from '@unimed-fesp/components';
import React from 'react';

import theme from '../../styles/theme';

import { CardPersonalInformation } from './styles';

import { InfoDisplayItem } from '../../components/atoms/InfoDisplayItem';

function DetalheSolicitacao({ data }) {
  return (
    <WrapperFlex column fullWidth>
      <CardPersonalInformation>
        <Title
          color={theme.greenDefault}
          fontSize={20}
          marginTop={10}
          marginBottom={5}
          text="Beneficiário"
        />
        <WrapperFlex gap={30}>
          <InfoDisplayItem title="Nome" content={data.beneficiaryName} />
          <InfoDisplayItem
            title="Código do Beneficiário"
            content={data.beneficiaryCode || data.progressUserCode}
          />
          <InfoDisplayItem
            title="Código Cartão"
            content={data.beneficiaryUniqueCode}
          />
          <InfoDisplayItem title="Via Atual" content={data.currentNumber} />
        </WrapperFlex>
      </CardPersonalInformation>
      <CardPersonalInformation>
        <Title
          color={theme.greenDefault}
          fontSize={20}
          marginTop={10}
          marginBottom={5}
          text="Contratante"
        />
        <WrapperFlex gap={20}>
          <WrapperFlex column width={500}>
            <InfoDisplayItem
              title="Código - Nome"
              content={`${data.contractorCode} - ${data.contractorName}`}
            />
            <WrapperFlex gap={20}>
              <InfoDisplayItem title="Modalidade" content={data.modalityCode} />
              <InfoDisplayItem title="Termo" content={data.termNumber} />
            </WrapperFlex>
          </WrapperFlex>
          <WrapperFlex column>
            <InfoDisplayItem
              title="Unidade de Atendimento"
              content={`${data.requisitionUnitCode} - ${data.nameRequisitionUnitCode}`}
            />
            <InfoDisplayItem
              title="Unidade de Negociação"
              content={`${data.negociationUnitCode} - ${data.nameNegociationUnitCode}`}
            />
          </WrapperFlex>
        </WrapperFlex>
      </CardPersonalInformation>
    </WrapperFlex>
  );
}

export default DetalheSolicitacao;
